import React from "react";
import CvDownload from "./CvDownload";
import "../assets/styles/Contact.scss";

function Contact() {
  return (
    <section id="contact" className="contact">
      <div className="contact-inner" data-reveal>
        <h2 className="contact-title">
          Birlikdə
          <br />
          işləyək<span className="ac">.</span>
        </h2>
        <p className="contact-sub">
          Yeni layihə, əməkdaşlıq təklifi və ya sadəcə salam — aşağıdakı
          linklərdən əlaqə saxlaya bilərsən.
        </p>

        <div className="contact-links">
          <a
            href="https://www.linkedin.com/in/sarkhan-babayev/"
            target="_blank"
            rel="noreferrer"
            className="contact-row"
          >
            <span className="cr-name">LinkedIn</span>
            <span className="cr-sub">Sarkhan Babayev</span>
            <span className="cr-arrow">↗</span>
          </a>
          <a
            href="https://github.com/TheSarKhan/"
            target="_blank"
            rel="noreferrer"
            className="contact-row"
          >
            <span className="cr-name">GitHub</span>
            <span className="cr-sub">TheSarKhan</span>
            <span className="cr-arrow">↗</span>
          </a>
          <CvDownload variant="row" />
        </div>
      </div>
    </section>
  );
}

export default Contact;
